<template>
  <div
    class="header"
    :class="{
      'header--mobile': isSmallScreen,
      'header--floating-toggle': isVerticalMenu && !isSmallScreen,
    }"
  >
    <v-app-bar
      flat
      app
      :dark="themeMode === 'dark' ? true : false"
      :color="themeMode === 'default' ? 'white' : ''"
      height="45px"
    >
      <v-btn
        v-if="isSmallScreen"
        icon
        class="menu-toggle-btn mx-1"
        :title="label.caption.menu"
        @click="toggleSidebar()"
      >
        <i class="pi pi-bars"></i>
      </v-btn>

      <div class="header__brand">
        <v-toolbar-title>
          <image-logo :mode="themeMode" />
        </v-toolbar-title>

        <button
          type="button"
          class="header-current-date ms-2 d-none d-lg-inline-flex"
        >
          <i class="pi pi-calendar p-fs-xl me-1"></i>
          {{ formattedDate }}
        </button>
      </div>

      <v-spacer></v-spacer>

      <div class="layout-topbar-menu">
        <ThemConfigurator v-if="!isSmallScreen" />

        <MessageDropDown />

        <v-divider vertical class="mx-lg-3 d-none d-lg-flex"></v-divider>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="logout">
              <v-icon small color="error">mdi-logout</v-icon>
            </v-btn>
          </template>
          <span>
            {{ label.button.logout }}
          </span>
        </v-tooltip>
      </div>
    </v-app-bar>

    <v-btn
      @click="toggleSidebar()"
      class="drawer-show"
      elevation="0"
      icon
      v-if="isVerticalMenu && !isSmallScreen"
    >
      <i class="pi pi-bars"></i>
    </v-btn>
    <div class="d-flex justify-end">
      <div>
        <v-row no-gutters>
          <!-- Mini-sidebar  -->
          <v-navigation-drawer
            v-if="!isSmallScreen"
            v-model="miniDrawer"
            app
            right
            mini-variant
            mini-variant-width="90"
            :permanent="miniDrawer"
            class="mini-sidebar"
            :disable-resize-watcher="true"
          >
            <v-list>
              <v-list-group
                v-for="(ma, maIndex) in modules"
                :key="`${maIndex}-b`"
                v-model="ma.active"
                @click="changeModule(ma.value)"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      class="p-fs-xxxs p-fw-semibold d-flex text-p-first flex-column mx-2 text-wrap"
                    >
                      <!-- <v-icon class="mb-2" color="first"> {{ ma.icon }}</v-icon> -->
                      <span :class="ma.icon" class="text-p-first mb-2"></span>
                      {{ ma.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <!-- <v-list-item
                  v-for="(subMa, subMaIndex) in ma.subItems"
                  :key="`${subMaIndex}-a`"
                  :to="{ name: subMa.value }"
                  dark
                  class="px-2 subMa-sidebar"
                  @click="changeModule(subMa.value)"
                >
                  <v-list-item-content>
                    <v-list-item-title class="p-fs-xxxs d-flex flex-column">
                      
                      {{ subMa.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item> -->

                <v-list
                  nav
                  v-for="(subMa, subMaIndex) in ma.subItems"
                  :key="`${subMaIndex}-a`"
                  @click="changeModule(subMa.value)"
                  class="subMa-sidebar"
                >
                  <v-list-item
                    :to="{ name: subMa.value }"
                    class="mb-0 mouse-change"
                  >
                    <v-list-item-action
                      class="d-flex justify-center align-center"
                    >
                      <!-- <v-icon size="15pt" color="#9f9f9f" class="mb-1">
                        {{ subMa.icon }}
                      </v-icon> -->
                      <span class="p-fs-xxxs text-p-black">
                        {{ subMa.text }}
                      </span>
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider></v-divider>
                </v-list>
              </v-list-group>
            </v-list>
          </v-navigation-drawer>

          <!-- Big sidebar -->
          <v-navigation-drawer
            v-model="drawer"
            app
            right
            :width="isSmallScreen ? 290 : 230"
            :temporary="isSmallScreen"
            :key="isSmallScreen ? 'mobile-sidebar' : updateModule"
            class="sidebar"
            :disable-resize-watcher="true"
          >
            <!-- <v-row class="fill-height justify-end" no-gutters> -->

            <!-- موبایل: مثل منوی میتا؛ پنل پارسینا یک ماژول دارد و تغییر ماژول ندارد -->
            <div v-if="isSmallScreen" class="sidebar-mobile-head">
              <div class="sidebar-module-switch">
                <span class="sidebar-module-switch__title">
                  <v-icon small class="text-p-first mx-2">
                    mdi-view-grid-outline
                  </v-icon>
                  {{ modules[0].text }}
                </span>
              </div>

              <v-btn
                icon
                small
                class="sidebar-mobile-close"
                :title="label.button.closeWindow"
                @click="drawer = false"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>

            <div class="py-2 mb-2">
              <v-text-field
                v-model="searchText"
                :placeholder="label.form.search"
                hide-details
                outlined
                dense
                class="text-start mb-2 mx-2"
                color="first"
                type="text"
                @input="search"
              >
                <template v-slot:append>
                  <v-tooltip bottom :open-on-focus="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        class="mouse-change"
                        @click="search"
                        small
                      >
                        mdi-magnify
                      </v-icon>
                    </template>
                    <span> {{ label.caption.search }} </span>
                  </v-tooltip>
                </template>
              </v-text-field>
              <div class="sidebar-bottom-caption pt-0 pb-1">
                <div class="d-flex justify-center align-center">
                  <span>
                    {{ appVersionLabel }}
                    <br />
                  </span>
                </div>
              </div>
              <v-list>
                <template v-for="(nav, navIndex) in filteredData">
                  <v-list-item
                    v-if="nav.to"
                    :key="`${navIndex}-a`"
                    :to="{ name: nav.to }"
                    link
                    @click="onSidebarNavClick(nav)"
                  >
                    <div class="d-flex align-center">
                      <v-list-item-icon>
                        <v-icon> {{ nav.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ nav.label }}</v-list-item-title>
                      </v-list-item-content>
                    </div>
                  </v-list-item>
                  <v-divider
                    class="divider-border my-1 mx-2"
                    :key="`${navIndex}-d`"
                    v-if="nav.divider"
                  ></v-divider>

                  <v-list-group
                    v-if="nav.subItems && nav.subItems.length > 0"
                    :key="`${navIndex}-b`"
                    :prepend-icon="`${nav.icon} first--text fa-em`"
                    v-model="nav.active"
                    append-icon="fas fa-chevron-down fa-sm"
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ nav.label }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item
                      class="bg-p-grid px-0"
                      v-for="(sub, subIndex) in nav.subItems"
                      :key="`${subIndex}-a`"
                      dark
                    >
                      <v-list-item-content
                        v-if="sub.subItems && sub.subItems.length > 0"
                      >
                        <v-expansion-panels>
                          <v-expansion-panel class="transparent panel-wrap">
                            <v-expansion-panel-header class="px-2">
                              <v-list-item-title class="pr-6">
                                <!-- <v-icon small color="dark" class="pe-3">
                                  {{ sub.icon }}
                                </v-icon> -->
                                {{ sub.label }}
                              </v-list-item-title>
                              <template v-slot:actions>
                                <v-icon color="dark"> mdi-chevron-down </v-icon>
                              </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <div>
                                <v-list-item
                                  v-for="(child, childIndex) in sub.subItems"
                                  :key="`${childIndex}-sub`"
                                  dark
                                >
                                  <v-list-item-content
                                    v-if="
                                      child.subItems &&
                                      child.subItems.length > 0
                                    "
                                  >
                                    <v-expansion-panels>
                                      <v-expansion-panel
                                        class="transparent panel-wrap-child"
                                      >
                                        <v-expansion-panel-header class="px-2">
                                          <v-list-item-title
                                            class="d-flex align-center"
                                          >
                                            <!-- <v-icon
                                                  small
                                                  color="dark"
                                                  class="pe-1"
                                                >
                                                  {{ child.icon }}
                                                  </v-icon> -->
                                            <div class="circle"></div>
                                            {{ child.label }}
                                          </v-list-item-title>
                                          <template v-slot:actions>
                                            <v-icon color="dark">
                                              mdi-chevron-down
                                            </v-icon>
                                          </template>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <div>
                                            <v-list-item
                                              v-for="(
                                                subChild, subChildIndex
                                              ) in child.subItems"
                                              :key="`${subChildIndex}-sub`"
                                              :to="{ name: subChild.to }"
                                              link
                                              dark
                                              @click="onSidebarNavClick(subChild)"
                                            >
                                              <!-- <v-list-item-icon class="px-2">
                                                <v-icon
                                                  x-small
                                                  class="mr-8"
                                                  color="first"
                                                  >{{ subChild.icon }}</v-icon
                                                >
                                              </v-list-item-icon> -->

                                              <v-list-item-content
                                                class="mr-15"
                                              >
                                                <v-list-item-title>
                                                  {{ subChild.label }}
                                                </v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                          </div>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>
                                  </v-list-item-content>

                                  <v-list-item-content v-else>
                                    <v-list-item
                                      :to="{ name: child.to }"
                                      link
                                      dark
                                      class="px-0 d-flex align-center"
                                      @click="onSidebarNavClick(child)"
                                    >
                                      <v-list-item-icon class="mr-2">
                                        <!-- <v-icon>{{ child.icon }}</v-icon> -->
                                        <div class="circle"></div>
                                      </v-list-item-icon>
                                      <v-list-item-content>
                                        <v-list-item-title class="pr-2">
                                          {{ child.label }}
                                        </v-list-item-title>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-list-item-content>

                      <v-list-item-content v-else>
                        <v-list-item
                          :to="{ name: sub.to }"
                          link
                          dark
                          class="my-1 px-0"
                          @click="onSidebarNavClick(sub)"
                        >
                          <!-- <v-list-item-icon class="mr-2">
                            <v-icon>{{ sub.icon }}</v-icon>
                          </v-list-item-icon> -->
                          <v-list-item-content class="pr-8">
                            <v-list-item-title>
                              {{ sub.label }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </template>
              </v-list>
            </div>

            <!-- </v-row> -->
          </v-navigation-drawer>
        </v-row>
      </div>

      <div
        :class="
          isSmallScreen || (!isVerticalMenu && !isSmallScreen)
            ? 'horizantal-meno-w'
            : isVerticalMenu && drawer
            ? 'drawer-open-w'
            : 'drawer-close-w'
        "
        class="pb-0 breadcrumbs d-flex justify-space-between align-center"
        style="margin-top: 45px"
      >
        <v-menu
          bottom
          rounded
          offset-y
          nudge-bottom="2"
          transition="slide-y-transition"
          style="width: 10px"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon size="40" v-on="on">
              <v-icon class="mx-3 first--text">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list-item-content>
              <ul class="pl-0 mouse-change">
                <v-col
                  cols="12"
                  @click="closeAllTab"
                  class="px-0 text-p-dark p-fs-xs"
                >
                  <span>
                    <v-icon small class="text-p-first ml-1">
                      mdi-close-circle-outline
                    </v-icon>
                    بستن همه تب ها
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  @click="pinAllTab"
                  class="px-0 text-p-dark p-fs-xs"
                >
                  <span>
                    <v-icon small class="text-p-first ml-1">
                      mdi-pin-outline
                    </v-icon>
                    پین کردن همه تب ها
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  @click="unpinAllTab"
                  class="px-0 text-p-dark p-fs-xs"
                >
                  <span>
                    <v-icon small class="text-p-first ml-1">
                      mdi-pin-off-outline
                    </v-icon>
                    حذف همه پین ها
                  </span>
                </v-col>
              </ul>
            </v-list-item-content>
          </v-card>
        </v-menu>
        <v-tabs
          background-color="bg-border"
          height="33"
          slider-size="0"
          next-icon="mdi-chevron-right"
          prev-icon="mdi-chevron-left"
          show-arrows
          optional
          v-model="tab"
        >
          <v-tab
            v-for="(item, index) in tabs"
            :key="index"
            :class="
              $route.name == item.routeName
                ? 'breadcrumbs-item-active'
                : 'breadcrumbs-item'
            "
            class="pe-0"
            @contextmenu.prevent.stop="handleClick($event, item)"
            @click="goTab(item.routeName)"
          >
            <a> {{ item.title }} </a>
            <v-icon
              size="8pt"
              class="deleteTabHeader"
              @click="deleteTab(index)"
            >
              mdi-close
            </v-icon>
          </v-tab>
        </v-tabs>
      </div>
    </div>

    <vue-simple-context-menu
      class="tab-right-click-menu"
      element-id="myFirstMenu"
      :options="optionsArray1"
      ref="vueSimpleContextMenu1"
      @option-clicked="optionClicked"
    >
    </vue-simple-context-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import label from "@/lang/StaticLabels.js";
import { appVersion, appVersionLabel } from "@/config/appVersion.js";
import ThemConfigurator from "./menu/ThemConfigurator";
import pparsina from "@/containers/navbars/pparsina.js";
import MessageDropDown from "./menu/Message";
import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import imageLogo from "@/components/images/Logo";
import moment from "moment-jalaali";

export default {
  name: "TheHeader",
  components: {
    VueSimpleContextMenu,
    ThemConfigurator,
    MessageDropDown,
    imageLogo,
  },
  computed: {
    ...mapGetters({
      updateModule: "updateModule",
      themeMode: "themeMode",
    }),
    formattedDate() {
      const weekDays = [
        "شنبه",
        "یکشنبه",
        "دوشنبه",
        "سه‌شنبه",
        "چهارشنبه",
        "پنج‌شنبه",
        "جمعه",
      ];
      const dayOfWeek = this.currentDate.weekday();
      return (
        weekDays[dayOfWeek] + " " + this.currentDate.format("jYYYY/jMM/jDD")
      );
    },
    isSmallScreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {
    updateModule() {
      setTimeout(() => {
        this.setNavbar();
      }, 100);
    },
    $route() {
      if (
        this.$route.matched[1] &&
        this.$route.matched[1].name != this.currentRouteParent
      ) {
        setTimeout(() => {
          this.setNavbar();
        }, 100);
      }
      this.currentRouteParent = this.$route.matched[1].name;
      this.syncActiveTab();
    },
    isSmallScreen(isSmall) {
      if (isSmall) {
        this.miniDrawer = true;
        this.drawer = false;
      } else if (JSON.parse(localStorage.getItem("mitaMenuType")) == false) {
        this.miniDrawer = false;
        this.drawer = false;
      } else {
        this.drawer = true;
      }
    },
  },
  data() {
    return {
      label,
      searchText: null,
      filteredData: [],
      tab: null,
      tabs: [
        {
          title: this.$route.meta.label,
          routeName: this.$route.name,
        },
      ],
      isActive: false,
      urlLocations: [],
      tabinfo: {},
      allMenu: [],

      active: false,
      value: 1,
      isVerticalMenu: true,
      drawer: true,
      miniDrawer: true,
      currentRouteParent: "ParsinaSupport",
      currentDate: moment(),
      navItems: null,
      pparsina,
      // نسخه از src/config/version.json خوانده می‌شود
      version: appVersion,
      appVersionLabel,
      selectedModule: null,
      modules: [
        {
          text: "پشتیبانی پارسینا",
          icon: "icon-system-managment  p-fs-big",
          active: false,
          value: "ParsinaSupport",
          subItems: null,
        },
      ],
      optionsArray1: [
        {
          name: "پین کردن",
          slug: "pin",
        },
        {
          name: "حذف پین",
          slug: "unpin",
        },
      ],

      activeChildPanels: [],
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("pparsinaX/logout");
    },
    search() {
      let list = [];
      if (!this.searchText) {
        this.filteredData = this.navItems;
        return;
      } else {
        const lowerSearchText = this.searchText.toLowerCase();
        this.allMenu.forEach((item) => {
          if (item.subItems && item.subItems.length > 0) {
            let found = item.subItems.filter(
              (z) => z.label && z.label.toLowerCase().includes(lowerSearchText),
            );
            item.subItems.forEach((c) => {
              if (c.subItems && c.subItems.length > 0) {
                let subFound = c.subItems.filter(
                  (z) =>
                    z.label && z.label.toLowerCase().includes(lowerSearchText),
                );
                if (subFound && subFound.length > 0) {
                  subFound.forEach((i) => {
                    list.push(i);
                  });
                }
              }
            });

            if (found && found.length > 0) {
              found.forEach((i) => {
                list.push(i);
              });
            }
          }
        });
        this.filteredData = list;
      }
    },
    toggleSidebar() {
      this.drawer = !this.drawer;
      setTimeout(() => {
        this.$store.commit("setUpdateModule", 1);
      }, 100);
    },
    // در موبایل منو بعد از انتخاب صفحه بسته می‌شود (مثل منوی میتا)
    onSidebarNavClick(nav, index) {
      this.addTab(nav, index);
      if (this.isSmallScreen) {
        this.drawer = false;
      }
    },
    setNavbar() {
      if (this.$route.matched[1].name == "ParsinaSupport") {
        this.navItems = this.pparsina;
        this.selectedModule = "ParsinaSupport";
      }
      setTimeout(() => {
        this.filteredData = this.navItems;
      }, 100);

      let found = this.tabs.find((i) => i.routeName == this.$route.name);
      if (!found) {
        this.tabs.push({
          title: this.$route.meta.label,
          routeName: this.$route.name,
        });
      }
    },
    changeModule(data) {
      if (data) {
        this.drawer = true;
        this.$router
          .push({ name: data })
          .catch(() => {})
          .catch(() => {});
        setTimeout(() => {
          this.$store.commit("setUpdateModule", 1);
        }, 100);
      }
    },
    checkActive(data) {
      if (this.$route.matched[1].value == data) {
        return true;
      } else {
        return false;
      }
    },
    addTab(data, index) {
      let found = this.tabs.find((i) => i.routeName == data.to);
      let labelTitle = "";
      if (!found) {
        labelTitle = data.label;
        if (data.to == "PPARSINADashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pparsina;
        }
        this.tabs.push({
          title: labelTitle,
          routeName: data.to,
        });
        this.urlLocations.push(this.$route.name);
        this.$store.commit("setBreadcrumbs", this.urlLocations);
      }
      if (this.$refs.menuRefs && this.$refs.menuRefs[index]) {
        this.$refs.menuRefs[index].isActive = false;
      }
      this.syncActiveTab();
    },
    // ایندکس فعالِ v-tabs باید همیشه با روت جاری یکی باشد؛ در غیر این صورت
    // حالت active روی تب اشتباه می‌نشیند و ظاهر تب فعال ناپایدار می‌شود.
    syncActiveTab() {
      this.$nextTick(() => {
        const index = this.tabs.findIndex(
          (i) => i.routeName == this.$route.name,
        );
        this.tab = index == -1 ? null : index;
      });
    },
    goTab(data) {
      this.$router.push({ name: data }).catch(() => {});
      this.syncActiveTab();
    },
    deleteTab(index) {
      this.urlLocations = [];
      this.tabs.splice(index, 1);

      if (this.tabs.length > 0) {
        const routeName = this.tabs[this.tabs.length - 1].routeName;
        this.$router.push({ name: routeName }).catch(() => {});

        this.tabs.forEach((item) => {
          this.urlLocations.push(item.routeName);
        });
      } else {
        const fallbackRoute = "Dashboard";
        this.$router.push({ name: fallbackRoute }).catch(() => {});
        setTimeout(() => {
          this.tabs = [
            {
              title: this.$route.meta.label,
              routeName: this.$route.name,
            },
          ];
        }, 1000);
        this.urlLocations = [fallbackRoute];
      }
      this.$store.commit("setBreadcrumbs", this.urlLocations);
    },
    closeAllTab() {
      this.$router.push({ name: "Dashboard" }).catch(() => {});
      this.tabs = [
        {
          title: this.$route.meta.label,
          routeName: this.$route.name,
        },
      ];
    },
    pinAllTab() {
      localStorage.setItem("PinTabs", JSON.stringify(this.tabs));
    },
    unpinAllTab() {
      localStorage.setItem("PinTabs", []);
    },
    handleClick(e, data) {
      this.$refs.vueSimpleContextMenu1.showMenu(e);
      this.tabinfo = data;
    },
    optionClicked(e) {
      if (e.option.slug == "pin") {
        let data = JSON.parse(localStorage.PinTabs);
        data.push(this.tabinfo);
        localStorage.setItem("PinTabs", JSON.stringify(data));
      }
      if (e.option.slug == "unpin") {
        localStorage.setItem(
          "PinTabs",
          JSON.stringify(
            JSON.parse(localStorage.PinTabs).filter(
              (i) => i.routeName != this.tabinfo.routeName,
            ),
          ),
        );
      }
    },
  },
  mounted() {
    this.setNavbar();
    if (this.isSmallScreen) {
      this.drawer = false;
    }
    if (localStorage.getItem("PinTabs")) {
      this.tabs = JSON.parse(localStorage.PinTabs);
      this.tabs.forEach((item) => {
        this.urlLocations.push(item.routeName);
      });
      this.$store.commit("setBreadcrumbs", this.urlLocations);
    } else {
      this.tabs = [
        {
          title: this.$route.meta.label,
          routeName: this.$route.name,
        },
      ];
    }
    this.syncActiveTab();
    this.allMenu = [...this.pparsina];
  },
};
</script>

<style lang="css" scoped>
.input-cursor-pointer input {
  cursor: pointer !important;
}

.v-menu__content {
  width: 150px;
}
.divider-border {
  border-color: rgba(
    var(--color-first-r),
    var(--color-first-g),
    var(--color-first-b),
    0.15
  ) !important;
}
</style>
